export default [
    {
        // UserProfile will be rendered inside User's <router-view>
        // when /user/:id/profile is matched
        path: '/pointdeventes',
        name: 'outlets',
        component: () => import('../views/Outlet.vue'),
        meta: {
            requiresAuth: true,
            authorize: ['ROLE_ADMIN','ROLE_MANAGER'],
            layout: 'default',
            breadcrumb: 'points de vente',
            description: 'Gestion des points de vente'
        }
    }
]
